import { getQueryParams } from "../utils/helperFunctions";
let instance;

// Within the constructor, making sure the class hasn't already been instantiated.
class ChatBotMeta {
  constructor() {
    if (instance) {
      console.error("You can create only one instance!");
      return;
    }
    this.chatBotMeta = {};
    instance = this;
  }

  get() {
    // Updating meta with latest params and returning it.
    this.chatBotMeta = {
      ...getQueryParams(),
      ...this.chatBotMeta,
    };
    return this.chatBotMeta;
  }

  update(meta) {
    this.chatBotMeta = { ...this.chatBotMeta, ...meta };

    return this.chatBotMeta;
  }
}

const singletonChatBotMeta = new ChatBotMeta();
export default singletonChatBotMeta;
